import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'truncate',
})
export class TruncatePipe implements PipeTransform {
  transform(
    value: string,
    limit: number = 10,
    ellipsis: string = '...'
  ): string {
    if (value.length > limit) {
      return value.substring(0, limit) + ellipsis;
    }
    return value;
  }
}
